var _circle, _rect, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReportUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 11.5625,
    stroke: "#310048",
    strokeWidth: 1.875
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 13.6099,
    y: 13.334,
    width: 2.63889,
    height: 7.91667,
    fill: "#310048"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 13.6101,
    y: 8.05566,
    width: 2.63889,
    height: 2.63889,
    fill: "#310048"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReportUser);
export default __webpack_public_path__ + "static/media/report-user.72d4774451279902809738c55ec0c876.svg";
export { ForwardRef as ReactComponent };